import AudioPlayer from '../../../../../../components/audioplayer/audioplayer';
import augdowntown6 from '../../../../../../assets/augdowntown6.JPG';
import advpenguin from '../../../../../../assets/adventurepenguin.jpg';
import './jan21.css';


export default function Jan21() {

  return (

  
    < >

  
    
 
    
    <p className = 'sentence'> You know what’s interesting about people? We are all kind of inherently the same. <br></br> <br></br>


   
Sure, our professions differ:<br></br> bankers, teachers, IT people, custodians, bus drivers, athletes, whatever it is. <br></br> <br></br>

But fundamentally we all chase the same things: <br></br>Love, money, adventure, greatness, boobs and whatever else might come to mind. <br></br> <br></br>

So is there really a difference between any of us? Or are we all secretly just playing the same game?<br></br> <br></br>

Elon Musk is worth 700 and something billion dollars, is essentially a modern, semi-sovereign king, 54 years old and has like 12 kids. <br></br> <br></br>

When comparing someone like him to yourself, you might think that you have no similarities, but I am here to argue the opposite. <br></br> <br></br>
<img src = {augdowntown6} alt = "center" className = "img" /> <br></br> <br></br>

The only thing that is really different about him is the context within which he operates. <br></br> <br></br>

SpaceX’s primary goal is to “make star-trek real” which seems like a joke, but quite literally came out of his mouth during a presentation he gave about a week ago. <br></br> <br></br>

Think about your life, I’m sure that you have a weird (non-sexual) fantasy that you would like to bring to life. The only difference is that your attempt is to carve little men out of pieces of wood <br></br> <br></br> 
 and lay them on an artificial battle landscape in your basement to recreate the battle of Morannon, and Musk is building hundred-million-dollar rockets the size of buildings and chucking them up in the air. <br></br> <br></br>

I’m trolling, I’m not shaming you, honestly one is not better than the other, they are just different. The point is that when you really think about it, we aren’t all<br></br> <br></br> that different from one another. We all just want to live in our fantasies and we work in our own capacities to make that happen.

 - If you are going to make the argument about “well I’m not a billionaire” or something ridiculous, then please close my website and never open it again.  - <br></br> <br></br>

Anyways, the only real shame is when you don’t listen to your fantasies, and instead derive your desires and way of being from other people.  <br></br> <br></br>

Hypocritically, I think that telling people to not listen to other people is stupid, because in doing so they are listening to you, and you are another person, so… ?<br></br> <br></br>

What people should do is _______.<br></br> <br></br>


<img src = {advpenguin} alt = "center" className = "img2" /> <br></br> <br></br>
<p>This penguin is my favorite recent internet sensation.</p>















  </p>
  <div className = "youtube">
  <br></br>youtube: <a href = "https://www.youtube.com/@AugustDiStefano" target = "_blank" rel = "noopener noreferrer">
      https://www.youtube.com/@AugustDiStefano 
    </a>

    </div>
    </>

  )
}
